import * as App from '../../../../app';
import { SvgPath } from '../../../../lib/dom';
import { hexToRgba } from '../../../../lib/MediumColor/hexToRgba';
import { drawData } from './drawData';
var undoImg = new SvgPath({
    viewBox: '0 0 48 48',
    path: [
        'M28,14H16v8h12c2.8,0,5,2.2,5,5s-2.2,5-5,5h-3v8h3c7.2,0,13-5.8,13-13S35.2,14,28,14z',
        { tagName: 'polygon', attrs: { points: '5,18 19,6.3 19,29.7' } },
    ],
    fill: App.themes.get().cell,
    width: 48,
    height: 48,
});
var onLoad = function () { return App.emitter.emit('loadUndoImg', {}); };
export function drawSlices(canvas, slices, cellSize, alpha, drawBorder, cancelMoveFeature) {
    if (drawBorder === void 0) { drawBorder = false; }
    if (cancelMoveFeature === void 0) { cancelMoveFeature = false; }
    var cell = App.themes.get().cell;
    for (var i = 0; i < slices.length; i++) {
        var slice = slices[i];
        if (slice.hidden) {
            if (cancelMoveFeature && slice.shadow) {
                var image = undoImg.toImage(cell, onLoad);
                var pos = { x: slice.pos.x, y: slice.pos.y };
                drawData(canvas, slice.data, slice.cellSize, slice.gridSize, pos, drawBorder, 0.1);
                var x = pos.x + slice.cellSize * (slice.gridSize == 4 ? 2 : 1);
                var y = pos.y + slice.cellSize;
                var wh = slice.cellSize;
                canvas.fillCircle(x + wh / 2, y + wh / 2, wh, hexToRgba(cell, '0.15'));
                if (image && image.complete && image.width && image.height) {
                    canvas.drawImage(image, 0, 0, image.width, image.height, x, y, wh, wh);
                }
                else {
                    // canvas.fillRect(x, y, wh, wh, '#fff')
                    canvas.fillRect(x + wh * 0.2, y + wh * 0.4, wh * 0.8, wh * 0.2, cell);
                    canvas.beginPath();
                    canvas.moveTo(x, y + wh / 2);
                    canvas.lineTo(x + wh * 0.45, y + wh * 0.15);
                    canvas.lineTo(x + wh * 0.45, y + wh - wh * 0.15);
                    canvas.fillStyle(cell);
                    canvas.closePath();
                    canvas.fill();
                }
            }
        }
        else {
            var pos = { x: slice.pos.x + slice.move.x, y: slice.pos.y + slice.move.y };
            var sliceCellSize = slice.selected ? cellSize : slice.cellSize;
            drawData(canvas, slice.data, sliceCellSize, slice.gridSize, pos, drawBorder, alpha);
        }
    }
}
